import { Button } from "../Button";
import { Modal } from "../Modal";
import { Text } from "../Text";
import {
  ModalBody,
  ModalContent,
  ModalList,
  ModalTitleBlock,
  PersonalChatListRow,
} from "./PersonalChatListModal";

type Chat = {
  id: string;
  name: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  chats: readonly Chat[];
  onCloseAll: () => void;
  onOpenChat: (id: string) => void;
};

export function CloseAllPersonalChatsModal({
  open,
  onClose,
  chats,
  onCloseAll,
  onOpenChat,
}: Props) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalContent>
        {chats.length > 0 ? (
          <>
            <ModalTitleBlock>
              <Text variant="text-regular-md" color="var(--text-primary)">
                Close all chats
              </Text>
              <Text variant="text-regular" color="var(--text-secondary)">
                You have {chats.length} open{" "}
                {chats.length === 1 ? "chat" : "chats"}. Close{" "}
                {chats.length === 1 ? "it" : "them"} to start fresh — you can
                reopen {chats.length === 1 ? "it" : "them"} from history
                anytime.
              </Text>
            </ModalTitleBlock>
            <ModalBody>
              <ModalList>
                {chats.map((chat) => (
                  <PersonalChatListRow
                    key={chat.id}
                    id={chat.id}
                    name={chat.name}
                    showArrow
                    onClick={() => onOpenChat(chat.id)}
                  />
                ))}
              </ModalList>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button size="l" onClick={onCloseAll}>
                  {chats.length === 1 ? "Close" : "Close all"}
                </Button>
              </div>
            </ModalBody>
          </>
        ) : (
          <ModalTitleBlock>
            <Text variant="text-regular-md" color="var(--text-primary)">
              Close all chats
            </Text>
            <Text variant="text-regular" color="var(--text-secondary)">
              You have no open chats to close.
            </Text>
          </ModalTitleBlock>
        )}
      </ModalContent>
    </Modal>
  );
}
